import animateOnScroll from "./animateOnScroll"

//animate elements
animateOnScroll([
    { selector: "#Element .element", offset: 0.25, multiple: true }
]);